var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0421 1.39102C10.8928 1.33121 10.7263 1.33121 10.5771 1.39102L3.11707 4.37477L10.8096 7.45102L18.5021 4.37477L11.0421 1.39102ZM19.5596 5.29852L11.4346 8.54852V18.451L19.5596 15.201V5.29852ZM10.1846 18.4523V8.54727L2.05957 5.29852V15.2023L10.1846 18.4523ZM10.1133 0.229766C10.5603 0.0510154 11.0589 0.0510154 11.5058 0.229766L20.4171 3.79477C20.5329 3.8412 20.6322 3.92126 20.7022 4.02463C20.7721 4.128 20.8095 4.24995 20.8096 4.37477V15.2023C20.8094 15.452 20.7344 15.696 20.5943 15.9028C20.4541 16.1096 20.2553 16.2696 20.0233 16.3623L11.0421 19.9548C10.8928 20.0146 10.7263 20.0146 10.5771 19.9548L1.59707 16.3623C1.36488 16.2698 1.16575 16.1098 1.02537 15.9031C0.884997 15.6963 0.809828 15.4522 0.80957 15.2023V4.37477C0.809599 4.24995 0.847 4.128 0.916954 4.02463C0.986908 3.92126 1.08621 3.8412 1.20207 3.79477L10.1133 0.229766Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCube);
export default __webpack_public_path__ + "static/media/Product-Cube.858d02c7beb4c4f0f35f04f5cf156e77.svg";
export { ForwardRef as ReactComponent };